import { format } from "date-fns"
import { FormComponentType } from "@components/FormBuilder/types"
import { GenericForm } from "@custom-types/form"
import { DropdownOptions } from "@custom-types/common"

export const getContractFormFields = ({
  organisationOptions = [],
  divisionOptions = [],
}: {
  organisationOptions: DropdownOptions
  divisionOptions: DropdownOptions
}): GenericForm => ({
  organisation_key: {
    title: "Organisation",
    editable: true,
    type: FormComponentType.Dropdown,
    options: organisationOptions,
  },
  division_key: {
    title: "Division",
    editable: true,
    type: FormComponentType.Dropdown,
    options: divisionOptions,
  },
  salesforce_id: {
    title: "Salesforce ID",
    editable: true,
    type: FormComponentType.Input,
  },
  salesforce_contact: {
    title: "Client Contact",
    editable: true,
    type: FormComponentType.Input,
  },
  salesforce_contact_email: {
    title: "Client Email",
    editable: true,
    type: FormComponentType.Input,
  },
  active: {
    title: "Active",
    editable: true,
    type: FormComponentType.Checkbox,
  },
  description: {
    title: "Description",
    editable: true,
    type: FormComponentType.Textarea,
  },
  sftp: {
    title: "SFTP",
    editable: true,
    type: FormComponentType.Input,
  },
  start_date: {
    title: "Start Date",
    editable: true,
    type: FormComponentType.Date,
    modifier: (value) => (value ? format(new Date(value), "dd/MM/yyyy") : ""),
  },
  end_date: {
    title: "End Date",
    editable: true,
    type: FormComponentType.Date,
    modifier: (value) => (value ? format(new Date(value), "dd/MM/yyyy") : ""),
  },
  webhook_url: {
    title: "Webhook url",
    editable: true,
    type: FormComponentType.Input,
  },
})
